import React, { useEffect, useState } from "react"
import tag from "../../../assets/icons/tag.svg"
import styles from "./MultipleSelect.scss"

interface IProps {
  options: [string]
  selectedOptions: [string]
  setSelectedCategories: (category: string) => void
}

const MultipleSelect = ({
  options,
  selectedOptions,
  setSelectedCategories
}: IProps) => {
  const [isSelectVisible, setIsSelectVisible] = useState<boolean>(false)

  window.onmousedown = e => {
    var el = e.target
    if (
      el.tagName.toLowerCase() == "option" &&
      el.parentNode.hasAttribute("multiple")
    ) {
      e.preventDefault()
      // toggle selection
      if (el.hasAttribute("selected")) el.removeAttribute("selected")
      else el.setAttribute("selected", "")

      // hack to correct buggy behavior
      setSelectedCategories(el.innerHTML)
      var select = el.parentNode.cloneNode(true)
      el.parentNode.parentNode.replaceChild(select, el.parentNode)
    } else {
      setIsSelectVisible(false)
    }
  }
  return (
    <div className={styles.container}>
      <div>
        <img src={tag} alt="themes" />
        <div onClick={() => setIsSelectVisible(!isSelectVisible)}>
          {!selectedOptions.length
            ? "Thématiques"
            : `${selectedOptions.length} Thématique(s)`}
        </div>
      </div>
      <div
        className={[
          isSelectVisible ? styles.opened : styles.closed,
          styles.test
        ].join(" ")}
      >
        <select multiple={true} size={options.length}>
          {options.map(opt => (
            <option
              key={opt}
              value={opt}
              selected={selectedOptions.includes(opt)}
            >
              {opt}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default MultipleSelect
